import { ChainID } from '@ankr.com/chains-list';

import { getChainGroups } from '../constants/groups';

const getGroupByChainId = (chainId?: ChainID) =>
  chainId
    ? getChainGroups().find(({ chains }) => chains.includes(chainId))
    : undefined;

export const getGroupIdByChainId = (chainId?: ChainID) =>
  getGroupByChainId(chainId)?.id;
